<template>
<div class="base-tab">
  <v-form ref="basic" v-model="valid">
    <v-text-field :label="`${$t('schema.builder.basic.form-name')}` + '*'" :value="schemaBuilder.name" :counter="100" :rules="nameRules" @change="update($event, 'name')" class="schema-name-input"></v-text-field>
    <v-switch class="base-builder-switch" :label="`${$t('schema.builder.basic.active')}`" :input-value="(schemaBuilder.status == 1) ? true : false" @change="toggleActive($event)"></v-switch>
    <v-switch class="base-builder-switch" :label="`${$t('schema.builder.basic.require-confirmation')}`" :input-value="(schemaBuilder.confirmation == 1) ? true : false" @change="toggleConfirm($event)"></v-switch>
    <v-switch class="base-builder-switch" :label="`${$t('schema.builder.basic.all-teams')}`" v-model="allTeams" @change="toggleAllTeams($event)"></v-switch>
    <v-switch v-if="$route.name !== 'schema-builder'" class="base-builder-switch" :label="`${$t('schema.builder.basic.copy_all')}`" v-model="copyAll" @change="update($event, 'copy_all')"></v-switch>
    <v-switch class="base-builder-switch" :label="`${$t('schema.builder.basic.all_fields_required')}`" v-model="allFieldsRequired" @change="toggleAllFieldsRequired($event)"></v-switch>
    <div v-if="!allTeams" class="base-team-picker">
      <v-select :items="teams" item-text="name" item-value="id" :menu-props="{ maxHeight: '400' }" :label="`${$t('schema.builder.basic.teams')}`" :hint="`${$t('schema.builder.basic.select-teams')}`" multiple persistent-hint
        v-model="schemaBuilder.teams" @input="triggerSetSelectedTeams"></v-select>
    </div>
    <v-select class="base-team-picker" :items="type.schemaType" item-text="name" item-value="value" :menu-props="{ maxHeight: '400' }" :label="`${$t('base.type')}`"  persistent-hint
      v-model="schemaBuilder.type" @change="update($event, 'type')"></v-select>
    <v-text-field  :rules="scoreRules" v-if="schemaBuilder.type==type.TEST" :label="`${$t('test.min_score')}` + '*'" :value="schemaBuilder.min_score" type="number"  @change="update($event, 'min_score')" class="schema-name-input"></v-text-field>
    <v-select v-if="schemaBuilder.type == 3" class="base-team-picker" :items="documentTypes" item-text="name" item-value="id" :menu-props="{ maxHeight: '400' }" :label="`${$t('base.type')}`"
       persistent-hint v-model="schemaBuilder.document_type_id" @change="update($event, 'document_type_id')"></v-select>
  </v-form>

</div>
</template>

<script>
import type from '@/enums/schemaType'
export default {
  data() {
    return {
      type,
      copyAll: false,
      allFieldsRequired: false,
      documentTypes: [],
      nameRules: [
        v => !!v || this.$t('schema.builder.basic.name-required'),
        v => (v && v.length <= 100) || this.$t('schema.builder.basic.too-long-name')
      ],
      scoreRules: [
        v => !!v || this.$t('test.score_required'),
        v => (v && !isNaN(v)) || this.$t('test.score_number')
      ],
      allTeams: false,
      valid: false
    }
  },
  computed: {
    schemaBuilder() {
      return this.$store.state.schemaBuilder
    },
    teams() {
      return this.$store.state.teams
    }
  },
  methods: {
    loadDocumentTypes() {
      return this.$http.get('document-types').then(data => {
        this.documentTypes = data.data
      })
    },
    update(value, type) {
      this.$store.commit("updateSchemaBuilderProperty", {
        value,
        type
      })
      if (type === "name" && this.$store.state.schemaBuilder.print.title === "") {
        this.$store.commit("updateSchemaBuilderPrintProperty", {
          prop: "title",
          value
        })
      }
    },
    toggleActive(isActive) {
      this.update(isActive ? 1 : 0, 'status')
    },
    toggleConfirm(isConfirm) {
      this.update(isConfirm ? 1 : 0, 'confirmation')
    },
    toggleAllFieldsRequired(allFieldsRequired){
      this.update(allFieldsRequired ? 1 : 0, 'all_fields_required')
    },
    toggleAllTeams(doAllTeams) {
      if (doAllTeams === true) {
        this.update(this.teams.map(team => team.id), 'teams')
      }
    },
    triggerSetSelectedTeams(val) {
      this.$store.commit("updateSchemaBuilderProperty", {
        value: val,
        type: "teams"
      })
    }
  },
  created() {
    this.loadDocumentTypes()
  },
  watch: {
    valid() {
      this.$emit('validated', this.valid)
    }
  }
}
</script>

<style>
.base-tab {
  padding-left: 5%;
}

.base-tab .schema-name-input {
  max-width: 400px;
}

.base-tab .base-team-picker {
  max-width: 400px;
  margin-bottom: 9px;
}

.base-tab .base-builder-switch {
  margin-top: 4px;
  margin-left: 13px;
}
</style>
